import { z } from 'zod';

export const GetCouponGoodsCountServiceRequestSchema = z.object({
  couponNo: z.number().int(),
  categoryCode: z.string().optional(),
});

export type GetCouponGoodsCountServiceRequest = z.infer<
  typeof GetCouponGoodsCountServiceRequestSchema
>;

export const GetCouponGoodsCountServiceResponseSchema = z.object({
  totalCount: z.number().int(),
});

export type GetCouponGoodsCountServiceResponse = z.infer<
  typeof GetCouponGoodsCountServiceResponseSchema
>;
